import React from "react";
import { Dialog } from "@progress/kendo-react-dialogs";
import "./../../css/MidnightClockingDialog.css";

import DIALOG_MIDNIGHT_ICON from "../../public/assets/midnightclocking.svg";

const MidnightClockingDialog = ({ isMobile, visible, countdown, onConfirm, onCancel }) => {
  // Diagnostic: confirm whether/when this dialog actually becomes visible on mobile.
  // console.debug("[MidnightClocking] MidnightClockingDialog render", { isMobile, visible, countdown });

  if (!visible) return null;

  return (
    <Dialog className={`midnight-dialog ${isMobile ? "mobile-midnight-dialog" : ""}`}>
      <div className="midnight-card">
        <div className="midnight-image">
          <img src={DIALOG_MIDNIGHT_ICON} alt="" />
        </div>

        <div className="midnight-content">
          <h2>Midnight is approaching</h2>
          <p>
            Your clocking is still running as midnight approaches. Click Yes if you're still
            working, and we'll start a new clocking for the next day. If not, your current
            clocking will stop at midnight.
          </p>
        </div>

        <div className="midnight-footer">
          <button
            className="cancel-button"
            onClick={onCancel}
            style={{ minWidth: 80 }}
          >
            No <span style={{ color: "#999", fontSize: 12 }}>{`(${countdown}s)`}</span>
          </button>
          <button
            className="confirm-button"
            onClick={onConfirm}
            style={{ minWidth: 80 }}
          >
            Yes
          </button>
        </div>
      </div>
    </Dialog>
  );
};

export default MidnightClockingDialog;
